import React from 'react';

import { QuestionCircleOutlined, LinkOutlined } from '@ant-design/icons';
import { Modal, Button, Typography } from 'antd';

import { HelpEntry } from '../../constants/helpTexts';

const { Paragraph } = Typography;

interface HelpModalProps {
  helpData: HelpEntry | null;
  onClose: () => void;
}

const HelpModal: React.FC<HelpModalProps> = ({ helpData, onClose }) => {
  return (
    <Modal
      visible={!!helpData}
      onCancel={onClose}
      wrapClassName="help-mode-modal"
      footer={
        helpData?.docUrl ? (
          <Button
            type="link"
            icon={<LinkOutlined />}
            href={helpData.docUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Подробнее в документации
          </Button>
        ) : null
      }
      title={
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <QuestionCircleOutlined style={{ color: '#1890ff', fontSize: 20 }} />
          {helpData?.title || 'Справка'}
        </span>
      }
      width={480}
      centered
      destroyOnClose
      zIndex={1100}
    >
      {helpData && (
        <Paragraph style={{ fontSize: 14, lineHeight: 1.6, margin: 0 }}>
          {helpData.description}
        </Paragraph>
      )}
    </Modal>
  );
};

export default HelpModal;
